import React, { forwardRef, use } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { IoIosArrowRoundBack } from 'react-icons/io';
import { IconContext } from 'react-icons';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { useStateValue } from '../state';

import 'antd/dist/antd.css';
import { DatePicker } from 'antd';
import { useEffect } from 'react';
import moment from 'moment-timezone';
import { fetchCurrentDate } from '../Api/date';

function Header() {
  const [{ date, user, locationId, roles }, dispatch] = useStateValue();
  const today = new Date();
  const ref = React.createRef();
  let location = useLocation();
  let history = useHistory();
  const [{ getRemaining }] = useStateValue();

  React.useEffect(() => {
    async function updateDate() {
      const currentDateStr = await fetchCurrentDate(locationId);
      // Parse using the known format from the API
      const newDate = moment(currentDateStr, 'YYYY-MM-DD HH:mm:ss');
      if (newDate.isValid()) {
        dispatch({ type: 'changeDate', newDate });
        dispatch({ type: 'changeApiDate', newDate });
      } else {
        console.error('Fetched date is invalid:', currentDateStr);
      }
    }
    updateDate();
  }, [locationId]);

  useEffect(() => {
    if (user && roles && roles.includes('opsManager') && location.pathname !== '/capacity') {
      history.push('/capacity');
    }
  }, [user, roles, locationId]);

  const handleClick = () => {
    history.push('/');
  };

  var result = date.isSame(moment());

  var locationShortName =
    locationId == 1 ? 'LV' : locationId == 2 ? 'OS' : locationId == 5 ? 'HI' : locationId == 7 ? 'NY' : '';

  const CustomInput = result
    ? forwardRef(({ value, onClick }, _ref) => (
        <span className="blue-underlined" onClick={onClick} ref={_ref}>
          Today
        </span>
      ))
    : forwardRef(({ value, onClick }, _ref) => (
        <span className="blue-underlined" onClick={onClick} ref={_ref}>
          {value}
        </span>
      ));

  const currentDate = result ? 'TODAY' : date.format('YYYY-MM-DD');
  const onChange = (date, dateString) => {
    if (date) {
      dispatch({
        type: 'changeDate',
        newDate: date,
      });
    }
  };

  if (user) {
    let time = location.pathname.split('/')[6];
    return (
      <Navbar collapseOnSelect className="fix" bg="light" fixed="top" expand="lg">
        <Nav.Item>
          <Link to="/logout">Logout</Link>
        </Nav.Item>

        <Navbar.Brand>
          {' '}
          {location.pathname == '/capacity' ? locationShortName + ' -' : ''}{' '}
          {location.pathname == '/'
            ? `Trips - `
            : location.pathname == '/capacity'
            ? `TOTAL= ${getRemaining?.total} `
            : location.pathname == '/logout'
            ? ''
            : location.pathname.split('/')[4] +
              ' - ' +
              location.pathname.split('/')[5] +
              ':' +
              (Number(time) < 10 ? `0${time}` : time) +
              ' - ' +
              currentDate}
          {location.pathname == '/' || location.pathname == '/capacity' ? (
            <DatePicker inputReadOnly value={date} format="YYYY-MM-DD" onChange={onChange} style={{ width: '140px' }} />
          ) : (
            // <DatePicker
            //   selected={moment(date.format('YYYY-MM-DD')).toDate()}
            //   onChange={(date) => {
            //     dispatch({
            //       type: 'changeDate',
            //       newDate: moment().year(date.getFullYear()).month(date.getMonth()).date(date.getDate()),
            //     });
            //   }}
            //   withPortal
            //   customInput={<CustomInput ref={ref} />}
            //   todayButton="Today"
            // />
            ''
          )}
        </Navbar.Brand>
        {/* <div className="corner-time">{location.pathname == '/' ? '' : location.pathname == '/logout'? '': location.pathname.split('/')[5] + ":" + location.pathname.split('/')[6] }</div> */}
        {location.pathname == '/' || location.pathname == '/capacity' ? (
          (roles && roles.includes('driver')) ||
          (roles.includes('opsManager') && locationId == 2 && (
            <>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                  {roles && roles.includes('opsManager') && (
                    <Nav.Link eventKey="3" as={Link} to={`/flights?location=${locationId}`}>
                      Flights
                    </Nav.Link>
                  )}
                </Nav>
              </Navbar.Collapse>
            </>
          )) ||
          (roles && roles.includes('Super Admin') && (
            <>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                  <Nav.Link eventKey="1" as={Link} to="/">
                    Trips
                  </Nav.Link>
                  <Nav.Link eventKey="2" as={Link} to="/capacity">
                    Levels
                  </Nav.Link>
                  <Nav.Link eventKey="4" as={Link} to={`/flights?location=${1}`}>
                    LV Flights
                  </Nav.Link>
                  <Nav.Link eventKey="5" as={Link} to={`/flights?location=${5}`}>
                    HI Flights
                  </Nav.Link>
                  <Nav.Link eventKey="6" as={Link} to={`/flights?location=${7}`}>
                    NY Flights
                  </Nav.Link>
                  <Nav.Link eventKey="7" as={Link} to={`/flights?location=${2}`}>
                    OS Flights
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </>
          )) || (
            <>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                  <Nav.Link eventKey="1" as={Link} to="/">
                    Trips
                  </Nav.Link>
                  <Nav.Link eventKey="2" as={Link} to="/capacity">
                    Levels
                  </Nav.Link>
                  {roles && roles.includes('opsManager') && (
                    <Nav.Link eventKey="3" as={Link} to={`/flights?location=${locationId}`}>
                      Flights
                    </Nav.Link>
                  )}
                </Nav>
              </Navbar.Collapse>
            </>
          )
        ) : (
          <IconContext.Provider value={{ color: '#9EA0A5', size: '2.2em' }}>
            <div>
              <IoIosArrowRoundBack onClick={handleClick} />
            </div>
          </IconContext.Provider>
        )}
      </Navbar>
    );
  } else {
    return null;
  }
}

export default withRouter(Header);
